<template>
  <div id="app">
    <a class="icp" href="https://beian.miit.gov.cn/">闽ICP备15011792号-3</a>
    <div class="bgBox">
      <div class="mainBox">
        <div class="btn">
          <div @click="hgLogin" class="active">
            <div>登录</div>
            <div v-show="honeShow" class="row"></div>
          </div>
          <div @click="hgRegister"  class="active">
            <div>注册</div>
            <div v-show="!honeShow" class="row"></div>
          </div>
        </div>
        <hgLogin ref="hgLogin" v-if="honeShow === true"></hgLogin>
        <hgRegister ref="hgRegister" v-if="honeShow === false" @sendMsg="sendMsg"></hgRegister>
      </div>
    </div>
  </div>
</template>

<script>
import hgLogin from '@/components/hgLogin1'
import hgRegister from '@/components/hgRegister1'
import forgetPswd from '@/components/forgetPswd'

export default {
  name: 'App',
  data () {
    return {
      honeShow: true
    }
  },
  mounted () {
    window.location.href += '?version=1.0.8'
  },
  components: {
    hgLogin,
    hgRegister,
    forgetPswd
  },
  methods: {
    // 注册成功回到登录界面
    sendMsg (val) {
      this.honeShow = true
    },
    hgLogin () {
      this.honeShow = true
      // this.$refs.hgLogin._empty()
      // this.$refs.hgRegister._empty()
    },
    hgRegister () {
      this.honeShow = false
      // this.$refs.hgLogin._empty()
      // this.$refs.hgRegister._empty()
    }
  }
}
</script>

<style>

body{
  padding: 0;
  margin: 0;
  min-width: 1000px;
}
#app {
  padding: 0;
  margin: 0;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  /* background: url('./assets/background.png') no-repeat; */
  background-size: 100% 100%;
  width: 100%;
  min-width: 1000px;
  height: 968px;
  position: relative;
}
.icp{
  position: absolute;
  font-size: 23px;
  z-index: 10;
  left: 1310px;
  top: 820px;
  color: white;
}
.bgBox {
  background: url('./assets/background.png') no-repeat;
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  background-size: cover;
}
.mainBox{
  background-image: url('./assets/loginBack.png');
  background-size: 100% 100%;
  width:566px;
  height: 576px;
  position: absolute;
  top: 225px;
  left: 60%;
}
.btn{
  margin-top: 50px;
  width: 566px;
  height: 44px;
  margin-bottom: 10px;
}
.btn>div{
  width: 280px;
  height: 44px;
  text-align: center;
  line-height: 44px;
  display: inline-block;
  font-size: 36px;
  color: #333;
  cursor: pointer;
}
.active{
  /* color: #3ea9ff !important; */
  color: white !important;
}
.row{
  width: 100px;
  height: 4px;
  background-image: url('./assets/row.png');
  margin-left: 90px;
  background-size: 100% 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue